import { State } from 'redux/utils/Data'

export default State()